import { Row, Col, Rate, Divider, Input, Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actualizacionCostoMasivo, getProveedorCostos, setProveedorPagoDirecto, startLoadAsistencia } from "../../../../context/actions/detalleActions";
import { Estrellas } from "./Estrellas";
import ModalForm from "../../../../components/modalForm/ModalForm";
import { ConsultarSanMarcos } from "./ConsultarSanMarcos";
import { InicioSeguimiento } from "./folder/forma/_InicioSeguimiento";

export const DatosSucursal = () => {
  const dispatch = useDispatch();
  const [archivoCostos, setArchivoCostos] = useState(null);
  const [enviandoCostos, setEnviandoCostos] = useState(false);
  //
  const { lp1, lp2, lp1m, lp2m, banderazo, xkm, proveedorSucursal, proveedorSucursalID } =
    useSelector((state) => state.detalleReducer.proveedorCostos);

  const { asistencia, proveedorPagoDirecto } = useSelector((state) => state.detalleReducer);
  const isRequired = proveedorSucursalID === 494;
  const proveedorPagoDirectoGuardado = asistencia?.proveedorPagoDirecto;
  const paso = asistencia.estatusID;
  const usuarioIniciaSeguimiento = asistencia?.usuarioIniciaSeguimiento;
  const phoneCliente  = asistencia?.telefono || null
  const phoneProveedor = asistencia?.proveedorSucursal?.proveedor?.contactoTelefono1 || null
  const id = asistencia.asistenciaID
  //
  useEffect(() => dispatch(getProveedorCostos()), []);

  if (!proveedorSucursal) return <div></div>;

  const {
    nombre,
    domicilio,
    telefono1,
    telefono2,
    telefono3,
    proveedor,
    comentarios,
  } = proveedorSucursal;

  const enviarCostos = async () => {
    setEnviandoCostos(true);
    const result = await actualizacionCostoMasivo(
      archivoCostos,
      proveedor.proveedorID
    );
    setEnviandoCostos(false);

    if (result.code === 0) {
      await dispatch(startLoadAsistencia(id, false));
      message.success("Cambio exitoso");
      setArchivoCostos(null);
      return;
    }

    message.error("error");
  };

  return (
    <div>
      {(paso === 3 || paso === 4 || usuarioIniciaSeguimiento) && <InicioSeguimiento />}
      <div className="subTitulo">{proveedor?.nombreComercial}</div>
      <div>
        <ConsultarSanMarcos asistenciaID={id} nombreComercial={proveedor?.nombreComercial} />
      </div>
      {proveedor?.proveedorID === "uIXYHYwoLS" && (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <Upload
            accept=".xls,.xlsx"
            beforeUpload={(file) => {
              setArchivoCostos(file);
              return false;
            }}
            fileList={archivoCostos ? [archivoCostos] : []}
            maxCount={1}
            onRemove={() => setArchivoCostos(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar Excel</Button>
          </Upload>
          <Button
            type="primary"
            disabled={!archivoCostos}
            loading={enviandoCostos}
            onClick={enviarCostos}
            style={{ marginTop: 10 }}
          >
            Enviar
          </Button>
        </div>
      )}
      {proveedorPagoDirectoGuardado && (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <span className="subTitulo">Proveedor Pago Directo: </span>
          <span>{proveedorPagoDirectoGuardado}</span>
        </div>
      )}
      {isRequired && !proveedorPagoDirectoGuardado && (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <span className="subTitulo">Proveedor Pago Directo:{" "}</span>
          <Input
            value={proveedorPagoDirecto}
            onChange={(e) => dispatch(setProveedorPagoDirecto(e.target.value))}
            placeholder="Campo obligatorio"
            style={{ marginTop: 5 }}
          />
        </div>
      )}
      <div>
        <Estrellas estrellas={proveedor?.estrellas} />
      </div>

      {/* {paso >= 2 && paso !== 5 && <ModalForm phone={phoneCliente}  asistenciaID={id} phoneProveedor={phoneProveedor}/>} */}

      <div style={{ marginTop: 10 }}>Sucursal {nombre}</div>
      <div>{domicilio}</div>
      <div>Horario de Atención: {proveedorSucursal.horarioAtencion}</div>
      <div>
        {telefono1} {telefono2} {telefono3}{" "}
      </div>
      <div>{comentarios}</div>
      <Row style={{ marginTop: 10, marginBottom: 15 }}>
        <Col span={12}>
          <span className="subTitulo">LP1: </span>
          {lp1}
        </Col>
        <Col span={12}>
          <span className="subTitulo">LP2:</span> {lp2}
        </Col>
        <Col span={12}>
          <span className="subTitulo">LP1m:</span> {lp1m}
        </Col>
        <Col span={12}>
          <span className="subTitulo">LP2m:</span> {lp2m}
        </Col>
        <Col span={12}>
          <span className="subTitulo">Banderazo:</span> {banderazo}
        </Col>
        <Col span={12}>
          <span className="subTitulo">X Km:</span> {xkm}
        </Col>
      </Row>

      <Divider />
    </div>
  );
};
